import { render } from "./PaymentForm.vue?vue&type=template&id=278ab4e2&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=ts"
export * from "./PaymentForm.vue?vue&type=script&lang=ts"

import "./PaymentForm.vue?vue&type=style&index=0&id=278ab4e2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-278ab4e2"

export default script